var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperclipIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4398 11.0497L12.2498 20.2397C11.124 21.3655 9.59699 21.998 8.0048 21.998C6.41262 21.998 4.88565 21.3655 3.7598 20.2397C2.63396 19.1138 2.00146 17.5869 2.00146 15.9947C2.00146 14.4025 2.63396 12.8755 3.7598 11.7497L12.3298 3.17967C13.0804 2.42778 14.0989 2.00485 15.1613 2.00391C16.2237 2.00297 17.2429 2.42411 17.9948 3.17467C18.7467 3.92523 19.1696 4.94374 19.1706 6.00613C19.1715 7.06853 18.7504 8.08778 17.9998 8.83967L9.4098 17.4097C9.03452 17.7849 8.52553 17.9958 7.9948 17.9958C7.46407 17.9958 6.95508 17.7849 6.5798 17.4097C6.20452 17.0344 5.99369 16.5254 5.99369 15.9947C5.99369 15.4639 6.20452 14.9549 6.5798 14.5797L15.0698 6.09967",
    stroke: "#101010",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclipIcon);
export default __webpack_public_path__ + "static/media/paperclip-icon.f5339412e446bc62800f8cda67c97ece.svg";
export { ForwardRef as ReactComponent };